import { Preset } from '~src/types/knife'

import Standart from './_standart.preset'

import Serrated from '../knives/_Serrated.knife'
import Punching from '../knives/_Punching.knife'

const preset: Preset = {
  title: {
    EN: 'ZESTAW ROZSZERZONY',
    PL: 'ZESTAW ROZSZERZONY',
  },
  knives: [...Standart.knives, Punching, Serrated],
}

export default preset
